var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var QuoteIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 18
  }), React.createElement("path", {
    d: "M17.5653 9.00005H21.7392V17.3479H13.3914V9.00005L17.5653 0.652222H21.7392L17.5653 9.00005Z"
  }), React.createElement("path", {
    d: "M5.04342 9.00005H9.00864V17.3479H0.869507V9.00005L5.04342 0.652222H9.21733L5.04342 9.00005Z"
  }), React.createElement("path", {
    d: "M38.4348 17.3479H34.2609L38.4348 9.00005H34.2609V0.652222H42.6087V9.00005L38.4348 17.3479Z"
  }), React.createElement("path", {
    d: "M50.9565 17.3479H46.7826L50.9565 9.00005H46.7826V0.652222H55.1304V9.00005L50.9565 17.3479Z"
  }));
};
export var QuoteIconGlyph = function (props) {
  return React.createElement(QuoteIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};